<template>
    <div>
        <!-- Filter Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h5 class="mb-0">{{ trans('Filter') }}</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <!-- Start Date -->
                    <div class="col-md-4">
                        <label for="date_start">{{ trans('Start Date') }}</label>
                        <vue-flatpickr
                            :modelValue="filter.date_start"
                            :config="{
                                allowInput: true,
                                altFormat: 'd/m/Y',
                                altInput: true,
                                dateFormat: 'Y-m-d',
                            }"
                            :placeholder="trans('Select start date')"
                            name="date_start"
                            class="form-control bg-white"
                            autocomplete="off"
                            @update:modelValue="onDateStartChange"
                        >
                        </vue-flatpickr>
                    </div>

                    <!-- End Date -->
                    <div class="col-md-4">
                        <label for="date_end">{{ trans('End Date') }}</label>
                        <vue-flatpickr
                            :modelValue="filter.date_end"
                            :config="{
                                allowInput: true,
                                altFormat: 'd/m/Y',
                                altInput: true,
                                dateFormat: 'Y-m-d',
                            }"
                            :placeholder="trans('Select end date')"
                            name="date_end"
                            class="form-control bg-white"
                            autocomplete="off"
                            @update:modelValue="onDateEndChange"
                        >
                        </vue-flatpickr>
                    </div>

                    <!-- Export Button -->
                    <div class="col-md-4 d-flex align-items-end">
                        <button
                            @click="exportToExcel"
                            :disabled="loadingExport || !filter.date_start || !filter.date_end"
                            class="btn btn-primary w-100"
                        >
                            <i class="icofont-download" v-if="!loadingExport" style="font-size: 14px;"></i>
                            <i class="icofont-spinner" v-else style="font-size: 14px;"></i>
                            {{ trans('Create XLS') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueFlatpickr from 'vue-flatpickr-component';
import { LocalDate } from '@js-joda/core';

export default {
    components: {
        VueFlatpickr,
    },
    data() {
        return {
            filter: {
                date_start: '',
                date_end: '',
            },
            loadingExport: false,
        };
    },
    mounted() {
        this.initializeDates();
    },
    methods: {
        initializeDates() {
            // Set start date to first day of current year
            const now = LocalDate.now();
            const startOfYear = now.withDayOfYear(1);
            const endOfYear = now.withDayOfYear(now.lengthOfYear());

            this.filter.date_start = startOfYear.toString();
            this.filter.date_end = endOfYear.toString();
        },
        onDateStartChange(value) {
            this.filter.date_start = value;

            // Validate date range: if start date is after end date, adjust end date
            if (value && this.filter.date_end) {
                const startDate = LocalDate.parse(value);
                const endDate = LocalDate.parse(this.filter.date_end);

                if (startDate.isAfter(endDate)) {
                    // Set end date to start date + 1 day
                    this.filter.date_end = startDate.plusDays(1).toString();
                }
            }
        },
        onDateEndChange(value) {
            this.filter.date_end = value;

            // Validate date range: if end date is before start date, adjust start date
            if (value && this.filter.date_start) {
                const startDate = LocalDate.parse(this.filter.date_start);
                const endDate = LocalDate.parse(value);

                if (endDate.isBefore(startDate)) {
                    // Set start date to end date - 1 day
                    this.filter.date_start = endDate.minusDays(1).toString();
                }
            }
        },
        async exportToExcel() {
            this.loadingExport = true;
            try {
                const response = await axios.post(route('antoon-decock.export-rsz-aangifte.export'), {
                    date_start: this.filter.date_start,
                    date_end: this.filter.date_end,
                }, {
                    responseType: 'blob'
                });

                // Create download link
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Extract filename from response headers or use default
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'Export RSZ Aangifte.xlsx';
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (filenameMatch) {
                        filename = filenameMatch[1];
                    }
                }

                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Error exporting to Excel:', error);
                // You might want to show a toast notification here
            } finally {
                this.loadingExport = false;
            }
        },
    },
};
</script>
